import * as z from "zod";
import { gql } from "graphql-request";

import { Sys, SysFragment } from "./sys";
import { Targeting, TargetingFragment } from "./targeting";
import { RelatedMedia, RelatedMediaFragment } from "./relatedMedia";
import {
  LocalizedSpotlight,
  LocalizedSpotlightFragment,
} from "./newsEntryTypes/localizedSpotlight";
import {
  CarouselEventPollEntry,
  CarouselEventPollEntryFragment,
} from "./newsEntryTypes/carouselEventPollEntry";
import {
  CarouselEventProgressTrackerEntry,
  CarouselEventProgressTrackerEntryFragment,
} from "./newsEntryTypes/carouselEventProgressTrackerEntry";

export const Spotlight = z.object({
  __typename: z.literal("Spotlight"),
  sys: Sys,
  sortDate: z.string().nullable(),
  newUntil: z.string().nullable(),
  size: z.enum(["small", "medium", "large"]).nullable(),
  video: z.string().nullable(),
  enableVideoSound: z.boolean().nullable().default(false),
  targeting: Targeting.nullable(),
  relatedMedia: RelatedMedia.nullable(),
  localized: z
    .discriminatedUnion("__typename", [
      LocalizedSpotlight,
      CarouselEventPollEntry,
      CarouselEventProgressTrackerEntry,
    ])
    .nullish(),
});

export type Spotlight = z.infer<typeof Spotlight>;

export const SpotlightFragment = gql`
  fragment SpotlightFragment on Spotlight {
    __typename
    sys {
      ...SysFragment
    }
    targeting {
      ...TargetingFragment
    }
    relatedMedia {
      ...RelatedMediaFragment
    }
    newUntil
    sortDate
    size
    video
    enableVideoSound
    localized {
      ... on LocalizedSpotlight {
        ...LocalizedSpotlightFragment
      }
      ... on CarouselEventPollEntry {
        ...CarouselEventPollEntryFragment
      }
      ... on CarouselEventProgressTrackerEntry {
        ...CarouselEventProgressTrackerEntryFragment
      }
    }
  }
  ${SysFragment}
  ${LocalizedSpotlightFragment}
  ${CarouselEventPollEntryFragment}
  ${CarouselEventProgressTrackerEntryFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
`;
